import { render, staticRenderFns } from "./MonthlySettings.vue?vue&type=template&id=60a65102"
import script from "./MonthlySettings.vue?vue&type=script&lang=js"
export * from "./MonthlySettings.vue?vue&type=script&lang=js"
import style0 from "./MonthlySettings.vue?vue&type=style&index=0&id=60a65102&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports